import _tcLib from "../../lib/timecode.js";
const tcLib = _tcLib;
export default (function addIncode(eventGroup, options) {
  if (!options.incode) {
    return eventGroup;
  }
  if (options.incode === "00:00:00:00") {
    return eventGroup;
  }
  let multiplier = options.frameRate === 23.976 || (options.frameRate == 29.97 || options.frameRate == 59.94) && !options.dropFrame ? 24 / 23.976 : 1;
  let incodeSec = parseFloat((tcLib.tcToSec(options.incode, options.frameRate, options.dropFrame, true) * multiplier).toFixed(3));
  if (!Number.isFinite(incodeSec)) {
    return eventGroup;
  }
  eventGroup.events.forEach((event, index, events) => {
    if (event.start === false || event.end === false || event.start === undefined || event.end === undefined) {
      return;
    }
    events[index].start += incodeSec;
    events[index].end += incodeSec;
  });
  return eventGroup;
});